import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

const STOREFRONT_URL = "https://chippedsocial.com";

// If the user ends up here without a user_id, route them to the storefront.
function RedirectToStorefront() {
  window.location.replace(STOREFRONT_URL);
  return null;
}

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<RedirectToStorefront />} />
      <Route path="/view-profile" element={<RedirectToStorefront />} />
      <Route path="/view-profile/:user_id" element={<App />} />
    </Routes>
  </BrowserRouter>
);
